import { AxiosInstance } from 'axios';

import { WorkloadOptimizationAPIApiFactory } from '@cast/openapi';

import { AXIOS_CONFIGURATION } from '../constants';

export const WorkloadOptimizationApiAdapter = (client: AxiosInstance) => {
  const generatedApi = WorkloadOptimizationAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    getAgentStatus: generatedApi.workloadOptimizationAPIGetAgentStatus,
    getOrganizationAgentStatuses:
      generatedApi.workloadOptimizationAPIGetOrganizationAgentStatuses,
    getWorkloads: generatedApi.workloadOptimizationAPIListWorkloads,
    getWorkload: generatedApi.workloadOptimizationAPIGetWorkload,
    getWorkloadSpec: generatedApi.workloadOptimizationAPIGetWorkloadSpec,
    getNativeVpaSpec:
      generatedApi.workloadOptimizationAPIGetWorkloadNativeVpaSpec,
    updateWorkload: generatedApi.workloadOptimizationAPIUpdateWorkloadV2,
    patchWorkload: generatedApi.workloadOptimizationAPIPatchWorkloadV2,
    getWorkloadRecommendationManifest:
      generatedApi.workloadOptimizationAPIGetWorkloadRecommendationManifest,
    getEvents: generatedApi.workloadOptimizationAPIListWorkloadEvents,
    getEvent: generatedApi.workloadOptimizationAPIGetWorkloadEvent,
    getEventsSummary:
      generatedApi.workloadOptimizationAPIGetWorkloadEventsSummary,
    getWorkloadOptimizationPolicies:
      generatedApi.workloadOptimizationAPIListWorkloadScalingPolicies,
    createWorkloadScalingPolicy:
      generatedApi.workloadOptimizationAPICreateWorkloadScalingPolicy,
    deleteWorkloadScalingPolicy:
      generatedApi.workloadOptimizationAPIDeleteWorkloadScalingPolicy,
    assignWorkloadsToPolicy:
      generatedApi.workloadOptimizationAPIAssignScalingPolicyWorkloads,
    updateWorkloadScalingPolicy:
      generatedApi.workloadOptimizationAPIUpdateWorkloadScalingPolicy,
    updateWorkloadScalingPoliciesOrder:
      generatedApi.workloadOptimizationAPISetScalingPoliciesOrder,
    getWorkloadsOptimizationSummary:
      generatedApi.workloadOptimizationAPIGetWorkloadsSummary,
    getWorkloadsResourceQuotas:
      generatedApi.workloadOptimizationAPIListResourceQuotas,
    getWorkloadsLimitRanges:
      generatedApi.workloadOptimizationAPIListLimitRanges,
    getWorkloadsSummaryMetrics:
      generatedApi.workloadOptimizationAPIGetWorkloadsSummaryMetrics,
    getWorkloadFilters: generatedApi.workloadOptimizationAPIGetWorkloadFilters,
    getCustomMetricsDataSources:
      generatedApi.workloadOptimizationAPIListCustomMetricsDataSources,
    createCustomMetricsDataSource:
      generatedApi.workloadOptimizationAPICreateCustomMetricsDataSource,
    updateCustomMetricsDataSource:
      generatedApi.workloadOptimizationAPIUpdateCustomMetricsDataSource,
    deleteCustomMetricsDataSource:
      generatedApi.workloadOptimizationAPIDeleteCustomMetricsDataSource,
    getHpaV2MigrationEligibility:
      generatedApi.workloadOptimizationAPIGetHPAV2MigrationEligibility,
    migrateClusterToHpaV2:
      generatedApi.workloadOptimizationAPIMigrateClusterToHPAV2,
    getAggregatedWorkloadCustomMetrics:
      generatedApi.workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta,
    listClusterHPAs: generatedApi.workloadOptimizationAPIListClusterHPAs,
    getWorkloadGpuMetrics:
      generatedApi.workloadOptimizationAPIGetWorkloadGPUMetrics,
    getWorkloadsAccessContext:
      generatedApi.workloadOptimizationAPIGetWorkloadsAccessContext,
    queryWorkloadMetrics:
      generatedApi.workloadOptimizationAPIQueryWorkloadMetrics,
  };
};
